export async function fetchPageData(collectionType, thePage) {
    // console.log("fetchpagedata")
    let url = "https://strapi.understory.community/";
    let theResponse;
    let fullUrl = url + collectionType + "?pagetype.name=" + thePage;
    // console.log("fullUrl", fullUrl)
    theResponse = fetch(fullUrl)
        .then(response => response.json())
    // .then(console.log("theResponse", theResponse))
    return await theResponse;
}